import React from 'react'
import MixedLeadsList from './mixed'
import MixedLeadsListIndividual from './mixedIndividual'

function MixedLeadsMain() {
  const role = JSON.parse((localStorage.getItem('kt-auth-react-v') as any) || {})?.data?.role?.role_id

  console.log(role)
  return <>{role === 1 || role === 2 ? <MixedLeadsList /> : <MixedLeadsListIndividual />}</>
}

export default MixedLeadsMain
